// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrderProduct_wrapper__1PGVX","product":"OrderProduct_product__2ekrx","image":"OrderProduct_image__3vN_k","price":"OrderProduct_price__2umyr"};